import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { BiSupport } from "react-icons/bi";
import { MdOutlineDashboard } from "react-icons/md";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import { BiWalletAlt } from "react-icons/bi";

function Sidebar({ location, history }) {

  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [showSection, setShowSection] = React.useState("");
  const [loginData, setLoginData] = React.useState();
  const [roleId, setRollId] = React.useState();

  const onClickMenu = (url) => {
    history.push(url);
    setTimeout(() => {
      setNavbarOpen(!navbarOpen)
    }, 150);

  }

  useEffect(() => {

    let loginData = JSON.parse(localStorage.getItem('adminuser'));
    console.log("loginDataloginDataloginData", loginData.roleId);
    setRollId(loginData.roleId)

  }, []);

  return (
    <>
      <button className={` ${navbarOpen === true ? 'hidden' : 'flex'} absolute top-0 left-0 px-5 items-center justify-center border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-800 focus:text-gray-600 z-50 h-16 lg:hidden `} onClick={() => setNavbarOpen(!navbarOpen)}>
        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 15.0003V17.0003H18V15.0003H0ZM14.404 0.904297L12.99 2.3183L16.172 5.5003L12.99 8.6823L14.404 10.0963L19 5.5003L14.404 0.904297ZM0 8.0003V10.0003H9V8.0003H0ZM0 1.0003V3.0003H9V1.0003H0Z" fill="black" />
        </svg>
      </button>

      {navbarOpen ?
        <div className={` ${navbarOpen === false ? 'hidden' : ''} lg:hidden lg:flex-shrink-0 lg:static inset-0 z-50 fixed bg-black bg-opacity-50`} onClick={() => setNavbarOpen(!navbarOpen)}>
          <div className="absolute top-0 z-40 flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600 left-72 lg:left-80 " aria-label="Close sidebar">
            <svg className="w-6 h-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12">
              </path>
            </svg>
          </div>
        </div>
        : null}

      <div className={` ${navbarOpen === false ? 'hidden' : 'flex'} fixed left-0 inset-y-0 lg:static lg:flex w-72 z-50 flex-col `} onClick={() => setNavbarOpen(!navbarOpen)}>
        <div className="relative flex flex-col flex-1 h-full max-h-full w-72">
          <div onClick={() => onClickMenu('dashboard')} className="z-50 flex items-center w-full h-20 px-2 py-2 pl-6 space-x-3 bg-black cursor-pointer">
            <img src="dist/img/fitclub-logo.png" className="w-10" alt="Fitclub-logo" />
            <span className="text-xl font-semibold text-white capitalize ">Lead Management</span>
          </div>

          <nav className="relative z-10 flex flex-col flex-wrap items-center justify-between h-full px-6 overflow-auto overflow-y-auto bg-black w-72">
            <div className="flex flex-col flex-wrap items-center justify-between flex-1 w-full mx-Lead Managementauto">
              <div className={"relative z-40 flex-1 w-full "}>
                <div className="mt-2">
                  <Link className={"text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  " + (location.pathname === "/app/dashboard" ? " text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]")} to="/app/dashboard" >
                    <MdOutlineDashboard className="text-[1rem]" />
                    <p> Dashboard</p>
                  </Link>
                </div>
                {roleId === 0 ?
                  <div className="mt-2">
                    <Link className={"text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  " + (location.pathname === "/app/user" ? " text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]")} to="/app/user" >
                      <BiSupport className="text-[1rem]" />
                      <p>User Management</p>
                    </Link>
                  </div> : null}

                <div className="cursor-pointer group">
                  {showSection === "leadManagement" ?
                    <span onClick={() => setShowSection("")} className="flex items-center px-1 py-2 space-x-4 text-sm text-black transition duration-150 ease-in-out cursor-pointer h-9">
                      <span className="text-[#75f94c]"><BiWalletAlt size={20} /></span>
                      <span className="text-sm text-[#75f94c] font-semibold lg:font-normal">Lead Management</span>
                      {showSection === "leadManagement" ? <HiChevronUp className="text-[#75f94c]" /> : < HiChevronDown className="text-[#75f94c]" />}
                    </span> :
                    <span onClick={() => setShowSection("leadManagement")} className="flex items-center px-1 py-2 space-x-4 text-sm text-black transition duration-150 ease-in-out cursor-pointer h-9">
                      <span className="text-[#75f94c]"><BiWalletAlt size={20} /> </span>
                      <span className="text-sm text-[#75f94c] font-semibold lg:font-normal">Lead Management</span>
                      {showSection === "leadManagement" ? <HiChevronUp className="text-[#75f94c]" /> : < HiChevronDown className="text-[#75f94c]" />}
                    </span>}
                  {showSection === "leadManagement" ?
                    <div>
                      <span onClick={() => onClickMenu('/app/new/Lead')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/new/Lead" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">New Lead</span>
                      </span>
                      <span onClick={() => onClickMenu('/app/contacted/Lead')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/contacted/Lead" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">Contacted Lead</span>
                      </span>
                      <span onClick={() => onClickMenu('/app/qualified/Lead')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/qualified/Lead" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">Qualified Lead</span>
                      </span>
                      <span onClick={() => onClickMenu('/app/converted/Lead')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/converted/Lead" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">Converted Lead</span>
                      </span>
                      <span onClick={() => onClickMenu('/app/lost/Lead')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/lost/Lead" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">Unsuccessful lead</span>
                      </span>
                    </div> : null}
                </div>

                {roleId === 0 ?
                  <div className="mt-2">
                    <Link className={"text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  " + (location.pathname === "/app/category" ? " text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]")} to="/app/category" >
                      <BiSupport className="text-[1rem]" />
                      <p>Category Management</p>
                    </Link>
                  </div> : null}
                <div className="cursor-pointer group">
                  {showSection === "reminder" ?
                    <span onClick={() => setShowSection("")} className="flex items-center px-1 py-2 space-x-4 text-sm text-black transition duration-150 ease-in-out cursor-pointer h-9">
                      <span className="text-[#75f94c]"><BiWalletAlt size={20} /></span>
                      <span className="text-sm text-[#75f94c] font-semibold lg:font-normal">Reminder Management</span>
                      {showSection === "reminder" ? <HiChevronUp className="text-[#75f94c]" /> : < HiChevronDown className="text-[#75f94c]" />}
                    </span> :
                    <span onClick={() => setShowSection("reminder")} className="flex items-center px-1 py-2 space-x-4 text-sm text-black transition duration-150 ease-in-out cursor-pointer h-9">
                      <span className="text-[#75f94c]"><BiWalletAlt size={20} /> </span>
                      <span className="text-sm text-[#75f94c] font-semibold lg:font-normal">Reminder Management</span>
                      {showSection === "reminder" ? <HiChevronUp className="text-[#75f94c]" /> : < HiChevronDown className="text-[#75f94c]" />}
                    </span>}
                  {showSection === "reminder" ?
                    <div>
                      <span onClick={() => onClickMenu('/app/active/reminder')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/active/reminder" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">Active Reminder</span>
                      </span>
                      <span onClick={() => onClickMenu('/app/deactive/reminder')} className={`text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  ${location.pathname === "/app/deactive/reminder" ? "text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]"}`}>
                        <span className="text-sm font-semibold lg:font-normal">InActive Reminder</span>
                      </span>
                    </div> : null}
                </div>


                {/* <div className="mt-2">
                  <Link className={"text-sm p-3 flex items-center space-x-4 hover:bg-[#FFFFFF]/10 rounded-md  " + (location.pathname === "/app/datePicker" ? " text-[#75f94c] bg-[#FFFFFF]/10" : "text-[#F5F4F7]")} to="/app/datePicker" >
                    <BiSupport className="text-[1rem]" />
                    <p>datePicker </p>
                  </Link>
                </div> */}


              </div>
            </div>
          </nav>

        </div>


      </div>
    </>
  );

}

export default withRouter(Sidebar);
